import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { BaasAppState, BaasI18n, BaasSecurityService, concatUrl } from '@lvflanders/bar';

import { BAR_CORE_CONSTANTS } from '../constants/bar-core.constants';
import { BAR_LOCALHOST } from '../constants/tokens.constants';
import { BarActieFromContext } from '../models/bar-actie-from-context.model';
import { BarCoreService } from '../services/bar-core.service';

export function barActieAllowedGuard(...acties: BarActieFromContext[]): CanActivateFn {
    return async () => {
        const security = inject(BaasSecurityService);
        const i18n = inject(BaasI18n);
        const appState = inject(BaasAppState);
        const core = inject(BarCoreService);
        const localhost = inject<boolean>(BAR_LOCALHOST);
        // iterate all acties
        for (const actie of acties) {
            const result = await security.checkActieAllowedFromContext(actie);
            if (!result) {
                if (!localhost) {
                    // perform hard redirect on deployed environment
                    window.location.href = concatUrl(appState.location.baasStatic.url, BAR_CORE_CONSTANTS.PAGES.INSUFFICIENT_PRIVILEGES);
                } else {
                    // on localhost emit an error, do not perform hard redirect
                    const errorMessage = i18n.get('DOMAIN_BAAS_CORE.INSUFFICIENT_PRIVILEGES_FOR_ACTIE', {
                        actie: actie.actie,
                        includeVoorwie: actie.includeVoorwie,
                        includeHoedanigheid: actie.includeHoedanigheid
                    });
                    console.error(errorMessage);
                    const error = new Error(errorMessage);
                    core.errorOccurred.emit(error);
                }
                return false;
            }
        }

        return true;
    };
}
